<h1>Vision Warehousing</h1>

<div class="p-grid">
  <div class="p-col-12 p-md-6 p-lg-4 p-xl-3">
    <p-card header="Piece Rate" *ngIf="canSeePieceRate">
      <ul>
        <li>
          <a routerLink="/piece-rate-form">Piece Rate Entry Form</a>
        </li>
      </ul>
    </p-card>
  </div>
  <div class="p-col-12 p-md-6 p-lg-4 p-xl-3">
    <p-card header="Shift Documents">
      <blob-storage
        [label]="'End Of Shift Files'"
        [fileTypes]="getFileTypes()"
        [entityId]="context?.id"
        [entityParent]="'WorkedShifts'"
        [documentIds]="workedShift?.documentIds"
        [siteId]="context?.site?.id"
        [editable]="true">
      </blob-storage>
    </p-card>
  </div>
</div>
<div *ngIf="siteInfo?.isScsSite">
  <div class="p-grid">
    <div class="p-col-12 p-lg-6 p-xl-4">
      <p-card header="Tower Comparison">
        <p>
          <file-import
            label="Comparison Tower"
            fileFormat="spreadsheets"
            [subinventories]="palletSubinventories">
          </file-import>
        </p>

        <p>
          <app-power-bi-report [report]="towerReport" [params]="params"></app-power-bi-report>
        </p>
      </p-card>
    </div>
    <div class="p-col-12 p-lg-6 p-xl-4" *ngIf="!siteInfo?.isTpm || siteInfo?.isSortOnlyRlc">
      <p-card header="PIMS Comparison">
        <p>
          <file-import
            label="Comparison PIMS"
            fileFormat="spreadsheets"
            [subinventories]="palletSubinventories">
          </file-import>
        </p>

        <p>
          <app-power-bi-report [report]="pimsReport" [params]="params"></app-power-bi-report>
        </p>
      </p-card>
    </div>
    <div class="p-col-12 p-lg-6 p-xl-4" *ngIf="materialsSubinventories?.length > 0">
      <p-card header="Materials Comparison">
        <p>
          <file-import
            label="Comparison Materials"
            fileFormat="spreadsheets"
            [subinventories]="materialsSubinventories">
          </file-import>
        </p>

        <p>
          <app-power-bi-report [report]="materialsReport" [params]="params"></app-power-bi-report>
        </p>
      </p-card>
    </div>
  </div>
  <div *ngIf="siteInfo?.hasPeco">
    <div class="p-grid">
      <div class="p-col-12 p-lg-6 p-xl-4">
        <p-card header="PECO Comparison">
          <p>
            <file-import
              label="Comparison PECO"
              fileFormat="spreadsheets"
              [subinventories]="pecoSubinventories">
            </file-import>
          </p>

          <p>
            <app-power-bi-report [report]="pecoReport" [params]="params"></app-power-bi-report>
          </p>
        </p-card>
      </div>
    </div>
  </div>
</div>
